module.exports = __webpack_public_path__ + "static/media/thomas_logo_no_bg.19574a98.svg";